import { render, staticRenderFns } from "./welcomeBeforeSession.vue?vue&type=template&id=0372d7cd&scoped=true"
import script from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
export * from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
import style0 from "./welcomeBeforeSession.vue?vue&type=style&index=0&id=0372d7cd&prod&scoped=true&lang=less"
import style1 from "./welcomeBeforeSession.vue?vue&type=style&index=1&id=0372d7cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372d7cd",
  null
  
)

export default component.exports